var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunctionalstatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4507_112709)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4507_112709",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4507_112709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4688 13.3594V22.4062C18.4688 23.0276 17.9651 23.5312 17.3438 23.5312H1.59375C0.972422 23.5312 0.46875 23.0276 0.46875 22.4062V1.59375C0.46875 0.972422 0.972422 0.46875 1.59375 0.46875H17.3438C17.9651 0.46875 18.4688 0.972422 18.4688 1.59375V9.66759",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94141 3.84375H11.9961C12.5462 3.84375 12.9922 3.39778 12.9922 2.84766V0.46875H5.94531V2.84766C5.94531 3.39778 6.39128 3.84375 6.94141 3.84375Z",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 21.6562H2.34375V18.7031V2.34375H5.79689",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5937 14.5781V21.6562H11.3438",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1406 2.34381H16.5938V11.4741",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4211 10.2218L17.6759 13.967L14.5156 15.374L15.9226 12.2138L21.4149 6.72146C21.899 6.23734 22.684 6.23734 23.1681 6.72146C23.6523 7.20559 23.6523 7.9906 23.1681 8.47473L21.4211 10.2218Z",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5731 13.8643L15.9644 12.2555",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5653 9.07715L20.812 7.32388",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 9.09375H4.59375V6.09375H7.59375V9.09375Z",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 14.25H4.59375V11.25H7.59375V14.25Z",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 19.4062H4.59375V16.4063H7.59375V19.4062Z",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2378 7.60903L11.2806 8.65186L13.3968 6.53564",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2378 12.7653L11.2806 13.8081L13.3968 11.6919",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7588 18.9644L12.875 16.8481",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7588 16.8481L12.875 18.9644",
    stroke: "#7F56D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4507_112709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalstatus);
export default __webpack_public_path__ + "static/media/functionalstatus.2890338e590c4c1b694c7368600f47e4.svg";
export { ForwardRef as ReactComponent };